import React from "react";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-between p-6 gradient-background">
      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-8 py-12">
        <h1 className="text-4xl md:text-6xl font-bold text-black animate-fade-up opacity-0" style={{ animationDelay: "0.2s" }}>
          Unlock Exclusive Deals At Your Favourite Restaurants
        </h1>
        <div className="p-6 rounded-lg border border-black/10 bg-gradient-to-br from-white to-[#33C3F0] shadow-lg max-w-3xl mx-auto animate-fade-up opacity-0" style={{ animationDelay: "0.4s" }}>
          <p className="text-lg md:text-xl text-black font-medium">
            <span className="font-bold">EatsBoost</span> rewards you for your continued visits by giving you exclusive offers on the food you love. Complete a few visits to start a Boost Cycle, Get Offers, and Enjoy. A new way to reshape your dining experience
          </p>
        </div>
        <div className="relative animate-fade-up opacity-0" style={{ animationDelay: "0.5s" }}>
          <p className="text-2xl md:text-3xl font-bold text-gray-800">
            Built to empower local eateries—the champions of our communities—to serve you better.
          </p>
        </div>
        <img 
          src="/lovable-uploads/7415354b-1912-441f-9a80-713ba069abd7.png" 
          alt="Star Badge"
          className="w-24 h-24 animate-fade-up opacity-0"
          style={{ animationDelay: "0.6s" }}
        />
      </div>
      <Button 
        className="animate-fade-up opacity-0 bg-white text-black hover:bg-gray-100"
        style={{ animationDelay: "0.7s" }}
        onClick={() => navigate("/how-it-works")}
      >
        How it Works
        <ArrowRight className="ml-2" />
      </Button>
    </div>
  );
};

export default Hero;
